import {Component} from 'react'
import {Field} from 'redux-form'

import Checkbox from './Checkbox.jsx'

import './CheckboxContainer.scss'

export class CheckboxContainer extends Component {
  render() {
    const {id, fields, meta} = this.props

    return (
      <div id={id} className="checkbox-container">
        {meta.error && (
          <div className="error-container text-center m-3">
            <span>{meta.error}</span>
          </div>
        )}
        <div className="d-flex flex-wrap justify-content-center">
          {fields.map((field, index) => {
            if (fields.getAll()[index].disabled) {
              return (
                <button
                  key={index}
                  className="btn btn-secondary m-1 btn-disabled"
                  type="button"
                  aria-disabled="true"
                  disabled
                >
                  {fields.getAll()[index].text}
                </button>
              )
            }
            return (
              <Field
                key={index}
                name={`${field}.value`}
                component={Checkbox}
                label={fields.getAll()[index].text}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

export default CheckboxContainer
